import Vue from "vue";
import Router from "vue-router";
import store from "./store";

const SignIn = () => import("./pages/SignIn");
const Dashboard = () => import("./pages/main/Dashboard");
const Usage = () => import("./pages/main/Usage");
const Performance = () => import("./pages/main/Performance");
const Coverage = () => import("./pages/main/Coverage");
const Datalink = () => import("./pages/main/Datalink");
const Definitions = () => import("./pages/main/Definitions");
const DatalinkHistory = () => import("./components/datalink/Index");
const DatalinkDetails = () => import("./components/datalink/details/Index");
const Admin = () => import("./pages/Admin");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/signIn",
      name: "signIn",
      component: SignIn,
      meta: { isPublic: true }, // required auth page is default.
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
    },
    {
      path: "/usage",
      name: "usage",
      component: Usage,
    },
    {
      path: "/performance",
      name: "performance",
      component: Performance,
    },
    {
      path: "/coverage",
      name: "coverage",
      component: Coverage,
    },
    {
      path: "/datalink",
      name: "datalink",
      component: Datalink,
      redirect: { name: "datalinkHistory" },
      children: [
        {
          path: "history",
          name: "datalinkHistory",
          component: DatalinkHistory,
        },
        {
          path: ":id/details",
          name: "dataLinkDetails",
          component: DatalinkDetails,
        },
      ],
    },
    {
      path: "/definitions",
      name: "definitions",
      component: Definitions,
    },
    {
      path: "/admin",
      meta: { isAdmin: true },
      component: Admin,
    },
    {
      path: "*",
      redirect: { name: "signIn" },
    },
  ],
});
router.beforeEach(async (to, from, next) => {
  const isPublic = to.meta["isPublic"];
  if (!isPublic) {
    let user = await store.dispatch("user/authCheck");
    const isAdmin = to.meta["isAdmin"];
    if (!user || !user.email || (isAdmin && !user.is_admin)) {
      next({ name: "signIn", query: { redirect: to.fullPath } });
    } else {
      store.dispatch("dashboard/setCurrentPage", to.name, { root: true });
      next();
    }
  } else {
    store.dispatch("dashboard/setCurrentPage", to.name, { root: true });
    next();
  }
});
export default router;
// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
